import { useEffect, useState } from "react";
import { colors, fonts, glyphs, images } from "../../Styles";
import { Graph_QL, useGetAutopig, useGetDomainLog } from "../../Services";
import { numberConverter } from "../../Definitions/valueTypes";
import { CoreWidget, NumberDisplay, NumberDisplayList } from "../BaseComponents";
import UNIT from "../BaseComponents/unit";
import NewButton from "../BaseComponents/newButton";

export default function BasicData() {

  // var Connections = Graph_QL.create([{domain:"demo"}, {domain:"tester"}])
  const {getState, stateData} = useGetAutopig(Graph_QL.create([{domain:"hkhornsyld", gate:9, device:40}]))

  const liveScale = stateData&&stateData[0] ? numberConverter(stateData[0].value1) : "No Data"
  const minScale = stateData&&stateData[0] ? numberConverter(stateData[0].value5) : "No Data"
  const maxScale = stateData&&stateData[0] ? numberConverter(stateData[0].value6) : "No Data"
  const todayAvg = stateData&&stateData[0] ? numberConverter(stateData[0].value2,100) : "No Data"
  const scaleCount = stateData&&stateData[0] ? stateData[0].value3 : "No Data"

  return(
      <CoreWidget 
        header={<p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary}}>Basic Data</p>}
        bgColor={colors.greyPrimary}
        width="320px"
        height="fit-content" 
        content={
          <div style={{width: "260px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "20px", paddingBottom: "20px"}}>
            <NumberDisplayList 
              headers={["In Batch", "Batch Age", "Yesterday Average", "Daily Growth Average"]} 
              headersColor={colors.greyTertiary}
              valuesColor={colors.greyLightTertiary}
              values={[28, 298, 36.97, 367]}
              gridGap="22px 20px"
              units={[
                <UNIT content={"Animals"} color={colors.greyTertiary}/>, 
                <UNIT content={"Days"} color={colors.greyTertiary}/>, 
                <UNIT content={"Kg"} color={colors.greyTertiary} glyph={<glyphs.Kg size="15px" fillColor={colors.greyTertiary}/>}/>, 
                <UNIT content={"G"} color={colors.greyTertiary} glyph={<glyphs.Kg size="15px" fillColor={colors.greyTertiary}/>}/>
              ]}
            />
            <div style={{width: "100%", height: "1px", backgroundColor: colors.greySecondary}}/>
            <NewButton
              content="View Animals"
            />
          </div>
        }>
      </CoreWidget>
  )
}